export default {
  'business-growth': 'Haz crecer tu negocio',
}
